import { useFormContext } from "react-hook-form";
import { LuDot } from "react-icons/lu";

export const ErrorMessageComponent = ({ message }: { message: string }) => {
  return (
    <div className="text-[#F01717] flex space-x-1 gap-1 text-left text-[14px] mt-1">
      <span className="flex items-center">
        <LuDot className="text-[#F01717]" />
      </span>
      <span>{message}</span>
    </div>
  );
};

type ErrorMessageProps = {
  fieldName: string;
};

export const ErrorMessage = ({ fieldName }: ErrorMessageProps) => {
  const method = useFormContext();

  if (!method) return null;
  const { formState } = method;

  const error = formState.errors[fieldName];

  if (error?.message) {
    return <ErrorMessageComponent message={error.message as string} />;
  }

  if (error && !error?.message) {
    {
      return Object.keys(error).map((rule, idx) => {
        const ruleObj = error[rule as keyof typeof error] as {
          message: string;
        };

        return (
          <div
            key={idx}
            className="text-[#F01717] flex space-x-1 text-center text-[14px] mt-1"
          >
            <span className="flex items-center">
              <LuDot className="text-[#F01717]" />
            </span>
            <span>{ruleObj?.message ?? ""}</span>
          </div>
        );
      });
    }
  }
};
